import api from './api';
import { uploadAwsFile } from './uploadService';
import { ApiResponse, PackagePlan, ClientPackage, PackageStats, PaginatedResponse, PackageRedeemableFor } from '../types';

export interface CreatePackagePlanDto {
  name: string; description?: string; mrp: number; price: number; gstRate: number; value: number;
  benefits?: string[]; applicableBranches?: string[]; termsAndConditions?: string;
  transferable?: boolean; autoRenewal?: boolean; redeemableFor?: PackageRedeemableFor;
  videos?: { title: string; youtubeUrl: string }[];
  isActive?: boolean;
}

const packageService = {
  getStats:       ()                       => api.get<ApiResponse<PackageStats>>('/packages/stats').then(r => r.data),
  getPlans:       (activeOnly?: boolean)    => api.get<ApiResponse<PackagePlan[]>>('/packages', { params: activeOnly ? { activeOnly: 'true' } : undefined }).then(r => r.data),
  createPlan:     (data: CreatePackagePlanDto) => api.post<ApiResponse<PackagePlan>>('/packages', data).then(r => r.data),
  updatePlan:     (id: string, data: Partial<CreatePackagePlanDto>) => api.put<ApiResponse<PackagePlan>>(`/packages/${id}`, data).then(r => r.data),
  uploadImage:    (id:string,file:File,title='Package image')=>uploadAwsFile(file,'packages',{targetId:id,title}).then(result=>({success:true,data:result.entity as PackagePlan} as ApiResponse<PackagePlan>)),
  deleteImage: (id:string,imageId:string)=>api.delete<ApiResponse<PackagePlan>>(`/packages/${id}/images/${imageId}`).then(r=>r.data),
  setFeatured: (id:string,imageId:string)=>api.put<ApiResponse<PackagePlan>>(`/packages/${id}/images/${imageId}/feature`).then(r=>r.data),
  setThumbnail: (id:string,imageId:string)=>api.put<ApiResponse<PackagePlan>>(`/packages/${id}/images/${imageId}/thumbnail`).then(r=>r.data),
  setInfographic: (id:string,imageId:string)=>api.put<ApiResponse<PackagePlan>>(`/packages/${id}/images/${imageId}/infographic`).then(r=>r.data),
  deletePlan:     (id: string)              => api.delete<ApiResponse>(`/packages/${id}`).then(r => r.data),
  getPurchases:   (params?: { clientId?: string; status?: string; page?: number; limit?: number }) =>
    api.get<PaginatedResponse<ClientPackage>>('/packages/purchases', { params }).then(r => r.data),
  getClientPackages: (clientId: string, activeOnly = false) =>
    api.get<ApiResponse<ClientPackage[]> & { activeBalance: number }>(`/packages/client/${clientId}`, {
      params: activeOnly ? { activeOnly: 'true' } : undefined,
    }).then(r => r.data),
  cancelPurchase: (id: string) => api.patch<ApiResponse<ClientPackage>>(`/packages/purchases/${id}/cancel`).then(r => r.data),
};

export default packageService;
